// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import PageContentBlock from '../../internal/PageContentBlock';
import AnchorLink from '../../internal/AnchorLink';
import type { ArticleType as FeaturedArticleType } from '../NewsArticle/Internal/FeaturedArticles';
import NewsArticleFeaturedArticles from '../NewsArticle/Internal/FeaturedArticles';
import { slugify } from '../../internal/util/slugify';
import Image from '../../components/Image';

type PropTypes = {|
  title: string,
  subtitle?: string,
  image: string,
  children: React.Node,
  featuredArticles: Array<FeaturedArticleType>,
|};

export default (props: PropTypes) => {
  const [links, setLinks] = React.useState([]);
  React.useEffect(() => {
    const tempLink = [];
    React.Children.forEach(
      props.children,
      ({
        type: { displayName },
        props: { text },
      }: {
        type: { displayName: string },
        props: { text: string },
      }) => {
        if (displayName === 'Section') {
          tempLink.push({
            href: slugify(text),
            text,
          });
        }
      },
    );
    setLinks(tempLink);
  }, [props.children]);

  return (
    <>
      <PageContentBlock>
        <div className={styles.container}>
          <h1 className={styles.title}>{props.title}</h1>
          {props.subtitle && <p className={styles.subtitle}>{props.subtitle}</p>}
          <ol className={styles.anchorLinks}>
            {links.map((link, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <li key={index}>
                <AnchorLink
                  href={link.href}
                  className={styles.link}
                  text={`${index + 1}. ${link.text}`}
                  offset={100}
                />
              </li>
            ))}
          </ol>
        </div>
      </PageContentBlock>
      <div className={styles.imageContainer}>
        <Image variant="Wide" image={props.image} alt="" />
      </div>
      <article>{props.children}</article>
      {props.featuredArticles && props.featuredArticles.length > 0 && (
        <NewsArticleFeaturedArticles articles={props.featuredArticles} />
      )}
    </>
  );
};
